// import { Post } from "../models";

export default {
  setPaginatedContactUs(state, payload) {
    state.contactUsPaginated = payload;
  },
  deleteContactUs(state, payload) {
    let index = state.contactUsPaginated.result.findIndex(x => x.id == payload.id);
    state.contactUsPaginated.result.splice(index, 1);
  },
  setContactUsColumn(state,payload){
    state.contactUsColumns = payload;
  },
  setContactUsTypeColumn(state,payload){
        state.contactUsTypeColumn = payload;
  },
   setContactUsTypeColumnNull(state){
        state.contactUsTypeColumn = [];
  },
  setContactUsConfig(state,payload){
    state.cotactUsConfig = payload;
    state.cotactUsConfigObject = payload?.[0]
  },
  setTypes(state,payload){
    state.types = payload;
  },
  setCount(state,payload){
    state.countactUsCount = payload.result.length;
  }
 
}